import { render, staticRenderFns } from "./3.vue?vue&type=template&id=7dcefa7d&"
import script from "./3.vue?vue&type=script&lang=js&"
export * from "./3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!/app/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Ripple } from 'vuetify/lib/directives'
installDirectives(component, {Ripple})
